import { render, staticRenderFns } from "./sumList.vue?vue&type=template&id=2b506293"
import script from "./sumList.vue?vue&type=script&lang=js"
export * from "./sumList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports